<span class="badge badge-{{ style }}">
    <ng-content></ng-content>
</span>
